import React from "react";
import { Button, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import KeyPicker from "../Vehicle/KeyPicker";
import {useKeysData} from "../../hooks/useKeysData";
import {useSelector} from "react-redux";
import {getKeysData} from "../../state/selectors";
import axios from "axios";



function KeyChangeModal({keys,open, setOpen, triggerChange, vehicle, save, selectedKey, filterField, onClear}){

    const keyObjects = keys.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});



    const onChange = e => {
        vehicle.key = keyObjects[e.target.value];
        triggerChange(vehicle);
    }

    const onButtonClick = (e) => {
        save();
        setOpen(false);
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    // TODO(bestax-migrate): `closeOnEsc` — bestax Modal closes on Esc by default; remove
    return (
        <Modal
            closeOnBlur
            active={open}
            closeOnEsc={true}
            onClose={() => {
                setOpen(false);
            }}
        >
            <Modal.Content>
                <Section style={{ backgroundColor: "white" }}>
                    <Title className={"is-centered"}>Change key</Title>
                    <KeyPicker
                        disabled={false}
                        keys={keys}
                        clearButton={true}
                        onKeyChange={onChange}
                        selectedKey={selectedKey}
                        filterField={filterField}
                        onClear={onClear}
                        spare={false}
                        filter={false}
                    />
                    <Button
                        onClick={onButtonClick}
                        color={"success"}
                        isFullWidth
                    >
                        Save
                    </Button>
                </Section>
            </Modal.Content>
        </Modal>
    );






}

export default KeyChangeModal;